import * as React from 'react';
import PropTypes from 'prop-types';
import InputContainer from './input-container';

export default class EmailFieldContainer extends React.Component {
	render() {
		return <InputContainer {...this.props} type="email" />;
	}
}

EmailFieldContainer.propTypes = {
	disabled    : PropTypes.bool,
	id          : PropTypes.string,
	label       : PropTypes.string,
	loading     : PropTypes.bool,
	multiline   : PropTypes.bool,
	name        : PropTypes.string.isRequired,
	placeholder : PropTypes.string,
	prefixes    : PropTypes.any,
	required    : PropTypes.bool,
	suffixes    : PropTypes.any,
	value       : PropTypes.string
}


// WEBPACK FOOTER //
// ./src/component/form/input/emailfield-container.js